import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 20px;\n    height: 48px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 34px;\n    height: 60px;\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 52px;\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 68px;\n  height: 70px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  background: #f5f1f2;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #000000;\n  opacity: 0.5;\n  z-index: -1;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      font-size: 9px;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      font-size: 11px;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      font-size: 13px;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  color: #ffffff;\n\n  z-index: 0;\n\n  p {\n    opacity: 1;\n    margin-bottom: 62px;\n  }\n\n  a {\n    border: 2px solid #ca9c66;\n    box-sizing: border-box;\n    border-radius: 6px;\n    padding: 1.3em;\n    text-transform: uppercase;\n    text-align: center;\n    font-style: normal;\n    font-weight: bold;\n    line-height: 18px;\n    letter-spacing: 3px;\n    line-height: 1em;\n    width: 100%;\n    \n    font-size: 18px;\n    ", "\n    ", "\n    ", "\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      font-size: 12px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      font-size: 18px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      font-size: 24px;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      font-size: 28px;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 24px;\n    max-width: 100%;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 36px;\n    max-width: 273px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  max-width: 342px;\n  padding: 40px;\n  margin: 0 auto;\n  ", "\n  ", "\n  ", "\n\n  h4 {\n    font-weight: 300;\n    font-family: \"Sofia thin\";\n    line-height: 110%;\n    margin-bottom: 18px;\n    \n    font-size: 36px;\n    ", "\n    ", "\n    ", "\n  }\n  p {\n    font-family: Inter;\n    line-height: 160%;\n    opacity: 0.8;\n    \n    font-size: 18px;\n    ", "\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var BaseWrapper = styled.div(_templateObject(), media.xxLargeScreen(_templateObject2()), media.xLargeScreen(_templateObject3()), media.smallScreen(_templateObject4()), media.xxLargeScreen(_templateObject5()), media.xLargeScreen(_templateObject6()), media.smallScreen(_templateObject7()), media.xxLargeScreen(_templateObject8()), media.smallScreen(_templateObject9()));
export var CtaWrapper = styled(BaseWrapper)(_templateObject10(), media.xxLargeScreen(_templateObject11()), media.xLargeScreen(_templateObject12()), media.smallScreen(_templateObject13()));
export var Overlay = styled.div(_templateObject14());
export var Wrapper = styled(BaseWrapper)(_templateObject15());
export var Image = styled.img(_templateObject16(), media.xxLargeScreen(_templateObject17()), media.xLargeScreen(_templateObject18()), media.smallScreen(_templateObject19()));